import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const baseUrl = process.env.REACT_APP_API_URL;
const imageUrl = process.env.REACT_APP_IMAGE_URL;

const Notice = () => {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const noticesUrl = `${baseUrl}/notices/`;
  const navigate = useNavigate();

  const buildImageUrl = (path) => {
    if (!path) return "";
    const normalizedBase = (imageUrl || "").replace(/\/$/, "");
    const normalizedPath = String(path).startsWith("/") ? path : `/${path}`;
    return `${normalizedBase}${normalizedPath}`;
  };

  const formatDate = (value) => {
    if (!value) return "N/A";
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? "N/A" : parsed.toLocaleDateString();
  };

  useEffect(() => {
    setLoading(true);
    setError("");

    axios
      .get(noticesUrl)
      .then((response) => {
        setNotices(response.data);
      })
      .catch((error) => {
        console.error("There was an error fetching the notices!", error);
        setError("Unable to load notices right now.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [noticesUrl]);

  const handleViewNotice = (id) => {
    navigate(`/notice/${id}`);
  };

  return (
    <div className="container my-4">
      <h2 className="mb-4 text-center">Notices</h2>

      {loading && <p className="text-center">Loading notices...</p>}
      {!loading && error && <p className="text-center text-danger">{error}</p>}
      {!loading && !error && notices.length === 0 && (
        <p className="text-center">No notices available.</p>
      )}

      <div className="row justify-content-center">
        {notices.map((notice, index) => (
          <div
            className="mb-3 card"
            key={notice.id}
            style={{
              maxWidth: "1200px",
              height: "200px",
              borderRadius: "50px 0 50px 0",
            }}
          >
            <div className="row g-0 h-100">
              <div className="col-md-2 h-100">
                {notice.image ? (
                  <img
                    src={buildImageUrl(notice.image)}
                    className="img-fluid h-100"
                    alt={notice.title}
                    style={{ objectFit: "cover", borderRadius: "50px 0 50px 0" }}
                  />
                ) : (
                  <div
                    className="d-flex align-items-center justify-content-center h-100"
                    style={{ borderRadius: "50px 0 50px 0" }}
                  >
                    No image
                  </div>
                )}
              </div>
              <div className="col-md-9">
                <div className="card-body">
                  <h5 className="card-title">{notice.title}</h5>
                  {/* <p className="card-text">{notice.description}</p> */}
                  <p className="text-sm text-gray-500">
                    <span>Published at: </span>
                    {formatDate(notice.created_at)}
                  </p>
                </div>
              </div>
              <div className="col-md-1 d-flex align-items-center">
                <button
                  className=" btn btn-success"
                  onClick={() => handleViewNotice(notice.id)}
                >
                  View{" "}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Notice;
